import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { fDate1, getCurrentDate, getPastDate } from "../utils/formatTime";

const publicUserListInitialData = {
  facilityID: 0,
  userName: "",
  userLastName: "",
  userFirstName: "",
  userEmail: "",
  phoneNumber: "",
  userCity: "",
  stateID: 0,
  activeStatus: 3,
  pageNo: 1,
  rowCountPerPage: 10,
  sortField: "",
};

const PublicUserInitialMessageSearch = {
  facilityID: '',
  inmateID: 0,
  inmateResidentID: "",
  managementUserID: 1,
  userID: 0,
  userFirstName: "",
  userLastName: "",
  inmateFirstName: "",
  inmateLastName: "",
  inmateFirstNameId: 0,
  inmateLastNameId: 0,
  messageDirection: "0",
  messageSendStartDate: getPastDate(6),
  messageSendEndDate: getCurrentDate(),
  messageFlag: "3",
  PageNo: 1,
  rowCountPerPage: 10,
  sortField: "MessageID DESC",
}

const PublicUserInitialPhotosSearch = {
  facilityID: '',
  inmateID: 0,
  inmateResidentID: "",
  managementUserID: 1,
  userID: '',
  userFirstName: "",
  userLastName: "",
  photoAccess: 0,
  inmateFirstName: "",
  inmateFirstNameID: 0,
  inmateLastName: "",
  inmateLastNameID: 0,
  subject: "",
  noticesFromDate: getPastDate(6),
  noticesToDate: getCurrentDate(),
  activeStatus: 4,
  receiverRead: 4,
  pageNo: 1,
  rowCountPerPage: 10,
  sortField: "PhotoCommID DESC",
}

const initialblockUnblock = {
  typ_PUIConnectionBlock: [],
  userFacilityID: 0,
  createdBy: 0,
};

// Create slice

const name = "publicUser";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const publicUserActions = { ...slice.actions, ...extraActions };
export const publicUserReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    publicUserList: publicUserListInitialData,
    publicUsersList: {},
    publicUserExcelList: {},
    infoInformationList: {},
    publicUsernotes: [],
    settingUpdateresponse: {},
    settingUpdateNotes: {},
    settingStatusHistory: {},
    settingExcelHistory: {},
    connectionList: {},
    connectionExcelList: {},
    connectionRelationUpdate: {},
    connectionBlockUnblockList: {},
    loginHistoryList: {},
    allLoginhistory: [],
    loginHistoryExcelList: {},
    inmateLastName: [],
    inmateFirstName: [],
    loadMessageExcelList: {},
    loadMessageList: {},
    loadPhotoList: {},
    photogridList: {},
    loadPhotoExcelList: {},
    loadPaymentList: {},
    loadPaymentExcelList: {},
    loadPaymentConfirmCancel: {},
    reportMessageList: [],
    reportPhotoList: [],
    LoadComplFundInmateDrpDwn: [],
    complCreditSubResponse: {},
    LoadClrFundInmateDrpDwn: [],
    LoadInmateConnectionAvailableBalance: [],
    fundClearResponse: {},
    connectionStructureData: initialblockUnblock,
    checkEventLogData: 0,
    eventlogdownload: {},
    PublicUserCurrentTab: "publicuser-info-tab",
    PublicUserrow: {},
    publicUserMessageValue: {},
    loading: false,
    error: null,
    LogReportsCurrrentTab: "logreport-kiosk-tab",
    puInitialMessageSearch: PublicUserInitialMessageSearch,
    PuIntitialphotosSearch: PublicUserInitialPhotosSearch
  };
}

function createReducers() {
  return {
    clearSettingUpdateResponse,
    clearSettingUpdateNotesResponse,
    clearSettingExcelHistory,
    clearloginHistoryExcelList,
    clearConnectionExcelList,
    clearMessageExcelList,
    clearPhotoExcelList,
    clearPhotoGridList,
    clearPaymentExcelList,
    clearPaymentConfrimCancel,
    setClearReportMessageList,
    setClearComplCreditSubResponse,
    setClearReportPhotoList,
    setfundClearResponse,
    setClearLoadInmateConnectionAvailableBalance,
    setConnectionList,
    setConnectionStructureData,
    clearconnectionBlockUnblockList,
    ClearconnectionStructureData,
    clearconnectionRelationUpdateResponse,
    setClearcheckEventLogDataResponse,
    setPublicUserTab,
    setPublicUserListRow,
    setpublicUserListSearch,
    clearpublicUserListSearch,
    setPublicMessageValue,
    clearpublicUserReportPhoto,
    setLogReportsCurrrentTab,
    clearloginHistoryList,
    clearDeletePublicListExcelList,
    setpuInitialMessageSearch,
    resetpuInitialMessageSearch,
    setPuIntitialphotosSearch,
    resetPuInitialPhotosSearch
  };
  /// clear funcs

  function setPuIntitialphotosSearch(state, action) {
    state.PuIntitialphotosSearch = action.payload;
  }

  function resetPuInitialPhotosSearch(state) {
    state.PuIntitialphotosSearch = PublicUserInitialPhotosSearch;
  }

  function setpuInitialMessageSearch(state, action) {
    state.puInitialMessageSearch = action.payload;;
  }

  function resetpuInitialMessageSearch(state) {
    state.puInitialMessageSearch = PublicUserInitialMessageSearch;
  }
  function clearSettingUpdateResponse(state) {
    state.settingUpdateresponse = {};
  }
  function clearSettingUpdateNotesResponse(state) {
    state.settingUpdateNotes = {};
  }
  function clearSettingExcelHistory(state) {
    state.settingExcelHistory = {};
  }
  function clearConnectionExcelList(state) {
    state.connectionExcelList = {};
  }
  function clearloginHistoryExcelList(state) {
    state.loginHistoryExcelList = {};
  }
  function clearMessageExcelList(state) {
    state.loadMessageExcelList = {};
  }
  function clearPhotoExcelList(state) {
    state.loadPhotoExcelList = {};
  }
  function clearPhotoGridList(state) {
    state.photogridList = {};
  }
  function clearPaymentExcelList(state) {
    state.loadPaymentExcelList = {};
  }
  function clearPaymentConfrimCancel(state) {
    state.loadPaymentConfirmCancel = {};
  }
  function setClearReportMessageList(state) {
    state.reportMessageList = [];
  }
  function setClearReportPhotoList(state) {
    state.reportPhotoList = [];
  }
  function setClearComplCreditSubResponse(state) {
    state.complCreditSubResponse = {};
  }
  function setfundClearResponse(state) {
    state.fundClearResponse = {};
  }
  function setClearLoadInmateConnectionAvailableBalance(state) {
    state.LoadInmateConnectionAvailableBalance = [];
  }
  function setConnectionList(state, action) {
    state.connectionList = action.payload;
  }
  function setConnectionStructureData(state, action) {
    state.connectionStructureData = action.payload;
  }
  function ClearconnectionStructureData(state) {
    state.connectionStructureData = initialblockUnblock;
  }
  function clearconnectionBlockUnblockList(state) {
    state.connectionBlockUnblockList = {};
  }
  function clearconnectionRelationUpdateResponse(state) {
    state.connectionRelationUpdate = {};
  }
  function setClearcheckEventLogDataResponse(state) {
    state.checkEventLogData = 0;
  }

  function setPublicUserTab(state, action) {
    state.PublicUserCurrentTab = action.payload;
  }
  function setPublicUserListRow(state, action) {
    state.PublicUserrow = action.payload;
  }

  function setpublicUserListSearch(state, action) {
    state.publicUserList = action && action.payload;
  }

  function clearpublicUserListSearch(state) {
    state.publicUserList = publicUserListInitialData;
  }
  function clearpublicUserReportPhoto(state) {
    state.loadPhotoList = {};
  }
  function clearloginHistoryList(state) {
    state.loginHistoryList = {};
  }
  function setPublicMessageValue(state, action) {
    state.publicUserMessageValue = action.payload;
  }
  function setLogReportsCurrrentTab(state, action) {
    state.LogReportsCurrrentTab = action.payload;
  }
  function clearDeletePublicListExcelList(state) {
    state.publicUserExcelList = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;
  const managebaseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/PublicUser`;
  const managebaseUrls = `${process.env.REACT_APP_API_URL}/ManagementUser/PublicUsers`;
  const masterbaseUrl = `${process.env.REACT_APP_API_URL}/Master`;

  return {
    LoadPublicUsersWithFacility: LoadPublicUsersWithFacility(),
    GetPublicuserDetails: GetPublicuserDetails(),
    GetNotes: GetNotes(),
    UpdateStatus: UpdateStatus(),
    UpdateNotes: UpdateNotes(),
    LoadAccountStatusHistory: LoadAccountStatusHistory(),
    LoadConnectionList: LoadConnectionList(),
    PUIRelationShipUpdateHistory: PUIRelationShipUpdateHistory(),
    BlockAndUnblockConnections: BlockAndUnblockConnections(),
    LoadLoginHistory: LoadLoginHistory(),
    GetInmateLastName: GetInmateLastName(),
    GetInmateFirstName: GetInmateFirstName(),
    LoadPUMessageSearch: LoadPUMessageSearch(),
    LoadPhotoSearchResult: LoadPhotoSearchResult(),
    LoadPhotoSearch: LoadPhotoSearch(),
    LoadPurchaseOrderTransaction: LoadPurchaseOrderTransaction(),
    PurchaseOrderTransactionUpdateWeb: PurchaseOrderTransactionUpdateWeb(),
    LoadMessageConversationPublicUser: LoadMessageConversationPublicUser(),
    LoadComplementaryFundPublicInmateConnectionDropDown:
      LoadComplementaryFundPublicInmateConnectionDropDown(),
    ComplimentaryCreditInsert: ComplimentaryCreditInsert(),
    LoadClearFundPublicInmateConnectionDropDown:
      LoadClearFundPublicInmateConnectionDropDown(),
    LoadPublicInmateConnectionAvailableBalance:
      LoadPublicInmateConnectionAvailableBalance(),
    ManuallyDecreaseCredit: ManuallyDecreaseCredit(),
    LoadEventLogData: LoadEventLogData(),
    GetEventLogFileAsBase64: GetEventLogFileAsBase64(),
  };

  function LoadPublicUsersWithFacility() {
    return createAsyncThunk(
      `${name}/LoadPublicUsersWithFacility`,
      async (params) => {
        return await fetchWrapper.post(
          `${managebaseUrls}/LoadPublicUsersWithFacility`,
          params
        );
      }
    );
  }

  ///
  function GetPublicuserDetails() {
    return createAsyncThunk(
      `${name}/GetPublicuserDetails`,
      async (publicUserID) => {
        return await fetchWrapper.get(
          `${managebaseUrls}/GetPublicuserDetails?publicUserID=${publicUserID}`
        );
      }
    );
  }

  ///
  function GetNotes() {
    return createAsyncThunk(
      `${name}/GetNotes`,
      async ({ publicUserID, facilityID }) => {
        return await fetchWrapper.get(
          `${managebaseUrl}/GetNotes?PublicUserID=${publicUserID}&facilityID=${facilityID}`
        );
      }
    );
  }
  /// update status
  function UpdateStatus() {
    return createAsyncThunk(
      `${name}/UpdateStatus`,
      async (params) =>
        await fetchWrapper.post(`${managebaseUrl}/UpdateStatus`, params)
    );
  }
  /// update Notes
  function UpdateNotes() {
    return createAsyncThunk(
      `${name}/UpdateNotes`,
      async (params) =>
        await fetchWrapper.post(`${managebaseUrl}/UpdateNotes`, params)
    );
  }
  /// history popup
  function LoadAccountStatusHistory() {
    return createAsyncThunk(
      `${name}/LoadAccountStatusHistory`,
      async ({ PublicUserID, PageNo, RowCountPerPage, SortField }) =>
        await fetchWrapper.post(
          `${managebaseUrl}/LoadAccountStatusHistory?PublicUserID=${PublicUserID}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}&SortField=${SortField}`
        )
    );
  }
  /// connection list
  function LoadConnectionList() {
    return createAsyncThunk(`${name}/LoadConnectionList`, async (params) => {
      return await fetchWrapper.post(
        `${managebaseUrl}/LoadConnectionList`,
        params
      );
    });
  }
  /// connection relatioship update
  function PUIRelationShipUpdateHistory() {
    return createAsyncThunk(
      `${name}/PUIRelationShipUpdateHistory`,
      async (params) => {
        return await fetchWrapper.post(
          `${managebaseUrls}/PUIRelationShipUpdateHistory`,
          params
        );
      }
    );
  }
  /// connection block/Unblock
  function BlockAndUnblockConnections() {
    return createAsyncThunk(
      `${name}/BlockAndUnblockConnections`,
      async (params) => {
        return await fetchWrapper.post(
          `${managebaseUrls}/BlockAndUnblockConnections`,
          params
        );
      }
    );
  }
  /// login list
  function LoadLoginHistory() {
    return createAsyncThunk(`${name}/LoadLoginHistory`, async (params) => {
      return await fetchWrapper.post(
        `${managebaseUrl}/LoadLoginHistory`,
        params
      );
    });
  }

  //// lastname drpdwn
  function GetInmateLastName() {
    return createAsyncThunk(
      `${name}/GetInmateLastName`,
      async ({ facilityID, firstName, PublicUserID }) =>
        await fetchWrapper.get(
          `${masterbaseUrl}/GetInmateLastName?facilityID=${facilityID}&firstName=${firstName}&publicUserID=${PublicUserID}`
        )
    );
  }
  //// firstname drpdwn
  function GetInmateFirstName() {
    return createAsyncThunk(
      `${name}/GetInmateFirstName`,
      async ({ facilityID, lastName, PublicUserID }) =>
        await fetchWrapper.get(
          `${masterbaseUrl}/GetInmateFirstName?facilityID=${facilityID}&lastName=${lastName}&publicUserID=${PublicUserID}`
        )
    );
  }
  //// ,message search
  function LoadPUMessageSearch() {
    return createAsyncThunk(
      `${name}/LoadPUMessageSearch`,
      async (data) =>
        await fetchWrapper.post(`${managebaseUrls}/LoadPUMessageSearch`, data)
    );
  }
  //Photo search
  function LoadPhotoSearch() {
    return createAsyncThunk(
      `${name}/LoadS3PhotosDetailsListDownload`,
      async (param) =>
        await fetchWrapper.post(`${baseUrl}/ManagementUser/Photos/LoadS3PhotosDetailsListDownload`,
          {
            ...param, PhotoSendStartDate: param?.noticesFromDate, PhotoSendEndDate: param?.noticesToDate,
            PhotoActionStatus: param?.activeStatus, publicFirstName: param?.userFirstName, publicLastName: param?.userLastName,
            PhotoSubject: param?.subject, PublicUserID: param?.userID,
          })
    );
  }
  //
  function LoadPhotoSearchResult() {
    return createAsyncThunk(
      `${name}/LoadPhotosList`,
      async (param) =>
        await fetchWrapper.post(
          `${baseUrl}/ManagementUser/Photos/LoadPhotosList`,
          {
            ...param, PhotoSendStartDate: param?.noticesFromDate, PhotoSendEndDate: param?.noticesToDate,
            PhotoActionStatus: param?.activeStatus, publicFirstName: param?.userFirstName, publicLastName: param?.userLastName,
            PhotoSubject: param?.subject, PublicUserID: param?.userID, SortBy: param?.sortField
          }
        )
    );
  }
  //payment search
  function LoadPurchaseOrderTransaction() {
    return createAsyncThunk(
      `${name}/LoadPurchaseOrderTransaction`,
      async (data) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadPurchaseOrderTransaction`,
          data
        )
    );
  }
  //payment confrim/Cancel
  function PurchaseOrderTransactionUpdateWeb() {
    return createAsyncThunk(
      `${name}/PurchaseOrderTransactionUpdateWeb`,
      async (data) =>
        await fetchWrapper.post(
          `${managebaseUrls}/PurchaseOrderTransactionUpdateWeb`,
          data
        )
    );
  }
  //Report/Message List
  function LoadMessageConversationPublicUser() {
    return createAsyncThunk(
      `${name}/LoadMessageConversationPublicUser`,
      async (data) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadMessageConversationPublicUser`,
          data
        )
    );
  }
  // setting Fund Complementry
  function LoadComplementaryFundPublicInmateConnectionDropDown() {
    return createAsyncThunk(
      `${name}/LoadComplementaryFundPublicInmateConnectionDropDown`,
      async ({ userID, facilityID }) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadComplementaryFundPublicInmateConnectionDropDown?userID=${userID}&facilityID=${facilityID}`
        )
    );
  }
  // setting Fund Complementry Submit
  function ComplimentaryCreditInsert() {
    return createAsyncThunk(
      `${name}/ComplimentaryCreditInsert`,
      async ({ pUIConnectionID, inmatesId, purcharseAmount, createdBy }) =>
        await fetchWrapper.post(
          `${managebaseUrls}/ComplimentaryCreditInsert?pUIConnectionID=${pUIConnectionID}&inmatesId=${inmatesId}&purcharseAmount=${purcharseAmount}&createdBy=${createdBy}`
        )
    );
  }
  // clear Fund Complementry Submit
  function LoadClearFundPublicInmateConnectionDropDown() {
    return createAsyncThunk(
      `${name}/LoadClearFundPublicInmateConnectionDropDown`,
      async ({ userID, facilityID }) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadClearFundPublicInmateConnectionDropDown?userID=${userID}&facilityID=${facilityID}`
        )
    );
  }
  // LoadPublicInmateConnectionAvailableBalance
  function LoadPublicInmateConnectionAvailableBalance() {
    return createAsyncThunk(
      `${name}/LoadPublicInmateConnectionAvailableBalance`,
      async ({ userID, facilityID, inmateId }) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadPublicInmateConnectionAvailableBalance?userID=${userID}&facilityID=${facilityID}&inmateId=${inmateId}`
        )
    );
  }
  // ManuallyDecreaseCredit
  function ManuallyDecreaseCredit() {
    return createAsyncThunk(
      `${name}/ManuallyDecreaseCredit`,
      async (params) =>
        await fetchWrapper.post(
          `${managebaseUrls}/ManuallyDecreaseCredit`,
          params
        )
    );
  }

  // check LoadEventLogData
  function LoadEventLogData() {
    return createAsyncThunk(
      `${name}/LoadEventLogData`,
      async ({ userID, publicUsername, EventLogDate }) =>
        await fetchWrapper.post(
          `${managebaseUrls}/LoadEventLogData?userID=${userID}&publicUsername=${publicUsername}&EventLogDate=${EventLogDate}`
        )
    );
  }
  // check LoadEventLogData
  function GetEventLogFileAsBase64() {
    return createAsyncThunk(
      `${name}/GetEventLogFileAsBase64`,
      async ({ userID, publicUsername, EventLogDate }, { rejectWithValue }) => {
        try {
          // Make the API request
          const response = await fetch(
            `${managebaseUrls}/GetEventLogFileAsBase64?userID=${userID}&publicUsername=${publicUsername}&EventLogDate=${EventLogDate}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Failed to fetch event log: ${response.statusText}`
            );
          }

          // Treat the response as plain text
          const textData = await response.text();

          // Create a Blob from the text data
          const blob = new Blob([textData], { type: "text/plain" });

          // Create a temporary link element to trigger the download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          // link.download = `EventLog_${EventLogDate}.txt`; // Set the file name
          const date = fDate1(EventLogDate);
          link.download = `${publicUsername}_${date}.log`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Revoke the object URL to free memory
          window.URL.revokeObjectURL(url);

          return { success: true };
        } catch (error) {
          return rejectWithValue({ success: false, message: error.message });
        }
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    ///
    .addCase(extraActions.LoadPublicUsersWithFacility.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicUsersWithFacility.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.publicUserExcelList = action.payload;
        } else {
          state.publicUsersList = action.payload;
        }

        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPublicUsersWithFacility.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )
    ///
    .addCase(extraActions.GetPublicuserDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetPublicuserDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.infoInformationList = action.payload;
    })
    .addCase(extraActions.GetPublicuserDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /// notes
    .addCase(extraActions.GetNotes.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetNotes.fulfilled, (state, action) => {
      state.loading = false;
      state.publicUsernotes = action.payload;
    })
    .addCase(extraActions.GetNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.UpdateStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.UpdateStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.settingUpdateresponse = action.payload;
    })
    .addCase(extraActions.UpdateStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.UpdateNotes.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.UpdateNotes.fulfilled, (state, action) => {
      state.loading = false;
      state.settingUpdateNotes = action.payload;
    })
    .addCase(extraActions.UpdateNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.LoadAccountStatusHistory.pending, (state) => {
      state.settingStatusHistory.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadAccountStatusHistory.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.settingExcelHistory = action.payload;
        } else {
          state.settingStatusHistory = action.payload;
        }

        state.settingStatusHistory.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadAccountStatusHistory.rejected,
      (state, action) => {
        state.settingStatusHistory.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(extraActions.LoadConnectionList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadConnectionList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.connectionExcelList = action.payload;
      } else {
        state.connectionList = action.payload;
      }

      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadConnectionList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.PUIRelationShipUpdateHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.PUIRelationShipUpdateHistory.fulfilled,
      (state, action) => {
        state.loading = false;
        state.connectionRelationUpdate = action.payload;
      }
    )
    .addCase(
      extraActions.PUIRelationShipUpdateHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(extraActions.BlockAndUnblockConnections.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.BlockAndUnblockConnections.fulfilled,
      (state, action) => {
        state.loading = false;
        state.connectionBlockUnblockList = action.payload;
      }
    )
    .addCase(
      extraActions.BlockAndUnblockConnections.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(extraActions.LoadLoginHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadLoginHistory.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loginHistoryExcelList = action.payload;
      }
      //  else if (params?.LoginType === 0) {
      //   state.allLoginhistory = action.payload;
      //   state.loginHistoryList = action.payload;
      // }
      else {
        state.loginHistoryList = action.payload;
      }

      state.loading = false;
      state.error = null;
    })

    .addCase(extraActions.LoadLoginHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    ////
    .addCase(extraActions.GetInmateLastName.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetInmateLastName.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateLastName = action.payload;
    })
    .addCase(extraActions.GetInmateLastName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    ///////
    .addCase(extraActions.GetInmateFirstName.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetInmateFirstName.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateFirstName = action.payload;
    })
    .addCase(extraActions.GetInmateFirstName.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    ///
    .addCase(extraActions.LoadPUMessageSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadPUMessageSearch.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loadMessageExcelList = action.payload;
      } else {
        state.loadMessageList = action.payload;
      }

      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadPUMessageSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.LoadPhotoSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadPhotoSearch.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loadPhotoExcelList = action.payload;
      } else {
        state.loadPhotoList = action.payload;
      }

      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    //LoadPhotoSearchResult
    .addCase(extraActions.LoadPhotoSearchResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearchResult.fulfilled, (state, action) => {
      state.loading = false;

      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loadPhotoExcelList = action.payload;
      } else {
        state.photogridList = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadPhotoSearchResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///
    .addCase(extraActions.LoadPurchaseOrderTransaction.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadPurchaseOrderTransaction.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.loadPaymentExcelList = action.payload;
        } else {
          state.loadPaymentList = action.payload;
        }

        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPurchaseOrderTransaction.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(
      extraActions.PurchaseOrderTransactionUpdateWeb.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.PurchaseOrderTransactionUpdateWeb.fulfilled,
      (state, action) => {
        state.loading = false;
        state.loadPaymentConfirmCancel = action.payload;
      }
    )
    .addCase(
      extraActions.PurchaseOrderTransactionUpdateWeb.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(
      extraActions.LoadMessageConversationPublicUser.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadMessageConversationPublicUser.fulfilled,
      (state, action) => {
        state.loading = false;
        state.reportMessageList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadMessageConversationPublicUser.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(
      extraActions.LoadComplementaryFundPublicInmateConnectionDropDown.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadComplementaryFundPublicInmateConnectionDropDown
        .fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadComplFundInmateDrpDwn = action.payload;
      }
    )
    .addCase(
      extraActions.LoadComplementaryFundPublicInmateConnectionDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(extraActions.ComplimentaryCreditInsert.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.ComplimentaryCreditInsert.fulfilled,
      (state, action) => {
        state.loading = false;
        state.complCreditSubResponse = action.payload;
      }
    )
    .addCase(
      extraActions.ComplimentaryCreditInsert.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(
      extraActions.LoadClearFundPublicInmateConnectionDropDown.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadClearFundPublicInmateConnectionDropDown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadClrFundInmateDrpDwn = action.payload;
      }
    )
    .addCase(
      extraActions.LoadClearFundPublicInmateConnectionDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(
      extraActions.LoadPublicInmateConnectionAvailableBalance.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadPublicInmateConnectionAvailableBalance.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadInmateConnectionAvailableBalance = action.payload;
      }
    )
    .addCase(
      extraActions.LoadPublicInmateConnectionAvailableBalance.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    ///
    .addCase(extraActions.ManuallyDecreaseCredit.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.ManuallyDecreaseCredit.fulfilled, (state, action) => {
      state.loading = false;
      state.fundClearResponse = action.payload;
    })
    .addCase(extraActions.ManuallyDecreaseCredit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///////
    .addCase(extraActions.LoadEventLogData.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadEventLogData.fulfilled, (state, action) => {
      state.loading = false;
      state.checkEventLogData = action.payload;
    })
    .addCase(extraActions.LoadEventLogData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ///////
    .addCase(extraActions.GetEventLogFileAsBase64.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.GetEventLogFileAsBase64.fulfilled,
      (state, action) => {
        state.loading = false;
        state.eventlogdownload = action.payload;
      }
    )
    .addCase(extraActions.GetEventLogFileAsBase64.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
